module.exports = __webpack_public_path__ + "static/media/schlauebox-logo.f75ef5c8.svg";